const currencyIntl = new Intl.NumberFormat('pt-BR', {
  style: 'currency',
  currency: 'BRL',
});

export const formatToDecimalCurrency = value => {
  return currencyIntl.format(value / 100);
};
